import { useState, useEffect } from "react";
import { handleSubmit } from "./addCertificateHandler";
import ImageUploader from "../ImageUploader";
import { Toggle, Message, useToaster } from "rsuite";
import { fetchCertificateCategories } from "../../../api/certificateAPI";

const ModalCertificate = ({ closeModal }) => {
  const [imageUrl, setImageUrl] = useState("");
  const [name, setName] = useState("");
  const [organizer, setOrganizer] = useState("");
  const [link, setLink] = useState("");
  const [status, setStatus] = useState(1);
  const [type, setType] = useState("");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const toaster = useToaster();

  useEffect(() => {
    fetchCertificateCategories().then(setCategories).catch(() => {});
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      await handleSubmit(e, name, imageUrl, organizer, link, status, type, closeModal, category);
      toaster.push(
        <Message showIcon type="success">Certificate added successfully!</Message>,
        { placement: 'topEnd' }
      );
    } catch (err) {
      toaster.push(
        <Message showIcon type="error">Failed to add certificate.</Message>,
        { placement: 'topEnd' }
      );
    }
  };

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
      {/* Container Utama dengan max-height 95vh agar tidak terpotong layar */}
      <div className="relative w-full max-w-5xl bg-white dark:bg-gray-800 rounded-[2rem] shadow-2xl flex flex-col max-h-[95vh] overflow-hidden border border-gray-100 dark:border-gray-700 animate-in fade-in zoom-in duration-300">
        
        {/* Header: Sticky (Tetap di atas) */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-5 text-white flex justify-between items-center shrink-0 shadow-md">
          <div className="flex items-center gap-3">
            <svg className="w-6 h-6 opacity-80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <h3 className="text-xl font-black tracking-tight uppercase italic leading-none">
                Create Certificate
              </h3>
              <p className="text-[10px] text-blue-100 opacity-70 mt-1 uppercase tracking-widest font-bold">New Portfolio Entry</p>
            </div>
          </div>
          <button 
            onClick={closeModal}
            className="p-2 hover:bg-white/20 rounded-full transition-all active:scale-90"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body Modal: Area yang bisa di-scroll */}
        <div className="overflow-y-auto p-8 lg:p-10 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
          <form onSubmit={handleFormSubmit}>
            <div className="grid grid-cols-1 gap-6">

              {/* Form Fields */}
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div className="md:col-span-2">
                    <label className="block mb-2 text-sm font-bold text-white dark:text-gray-300 uppercase tracking-tight">Certificate Name</label>
                    <input
                      required
                      type="text"
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                      placeholder="e.g. Professional Web Developer"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-bold text-white dark:text-gray-300 uppercase tracking-tight">Organizer</label>
                    <input
                      required
                      type="text"
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                      placeholder="e.g. Udemy / Coursera"
                      value={organizer}
                      onChange={(e) => setOrganizer(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-bold text-white dark:text-gray-300 uppercase tracking-tight">Type</label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                      placeholder="e.g. Course / Award"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block mb-2 text-sm font-bold text-white dark:text-gray-300 uppercase tracking-tight">Category</label>
                    <div className="flex gap-2">
                      <select
                        value={newCategory ? "" : category}
                        onChange={(e) => { setCategory(e.target.value); setNewCategory(""); }}
                        className="flex-1 px-4 py-3 bg-gray-50 dark:bg-gray-700 text-gray-800 dark:text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                      >
                        <option value="">-- Pilih / Buat Baru --</option>
                        {categories.map((c) => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </select>
                    </div>
                    <input
                      type="text"
                      className="mt-2 w-full px-4 py-2.5 bg-gray-50 dark:bg-gray-700 border border-dashed border-gray-300 dark:border-gray-500 text-gray-800 dark:text-white rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all text-sm placeholder:text-gray-400"
                      placeholder="Atau ketik kategori baru (misal: NOC, Cyber Security, Fullstack)..."
                      value={newCategory}
                      onChange={(e) => { setNewCategory(e.target.value); setCategory(e.target.value); }}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block mb-2 text-sm font-bold text-white dark:text-gray-300 uppercase tracking-tight">Credential Link</label>
                    <input
                      // type="url"
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all font-mono text-sm"
                      placeholder="https://verify.cert.com/id..."
                      value={link}
                      onChange={(e) => setLink(e.target.value)}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <ImageUploader
                      value={imageUrl}
                      onChange={setImageUrl}
                      label="Certificate Image"
                    />
                  </div>
                </div>

                {/* Status Section */}
                <div className="flex items-center justify-between p-5 bg-blue-50 dark:bg-blue-900/20 rounded-2xl border border-blue-100 dark:border-blue-800">
                  <div className="flex items-center gap-3">
                    <div className={`p-2 rounded-lg ${status === 1 ? 'bg-blue-600' : 'bg-gray-400'} text-white`}>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-sm font-black uppercase text-blue-900 dark:text-blue-200 tracking-wider">Visibility Status</p>
                      <p className="text-[11px] text-blue-700/60 dark:text-blue-300/40 font-bold uppercase leading-tight">
                        {status === 1 ? 'Visible on Portfolio' : 'Hidden from Portfolio'}
                      </p>
                    </div>
                  </div>
                  <Toggle
                    checked={status === 1}
                    onChange={(value) => setStatus(value ? 1 : 0)}
                    size="md"
                  />
                </div>
              </div>

            </div>

            {/* Footer Buttons: Tetap di dalam scroll area namun dipisah secara visual */}
            <div className="mt-10 pt-8 border-t border-gray-100 dark:border-gray-700 flex flex-col md:flex-row gap-4 justify-end">
              <button
                type="button"
                onClick={closeModal}
                className="px-8 py-3 text-sm font-black text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors uppercase tracking-widest"
              >
                Discard
              </button>
              <button
                type="submit"
                className="px-12 py-3 bg-blue-600 hover:bg-blue-700 text-white font-black rounded-xl shadow-lg shadow-blue-200 dark:shadow-none transition-all active:scale-95 flex items-center justify-center uppercase tracking-wider text-sm"
              >
                Create Certificate
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalCertificate;